<mat-card class="app-main-container">
  <mat-card-header class="custom-card-header">
    <mat-card-title class="card-title">
      <mat-icon class="title-icon">account_tree</mat-icon>
      {{ 'WORKCLASSIFICATION.TEMPLATES.TITLE' | translate }}
    </mat-card-title>
    <div class="responsive-actions header-actions">
      <button mat-stroked-button class="btn-secondary" (click)="openForm('fromProject')">
        <mat-icon>content_copy</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.CREATE_FROM_PROJECT' | translate }}
      </button>
      <button mat-flat-button class="btn-primary" (click)="openForm('create')">
        <mat-icon>add</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.NEW' | translate }}
      </button>
    </div>
  </mat-card-header>

  <mat-card-content class="app-container">
    <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.INTRO' | translate }}</p>

    <div class="app-row end">
      <mat-checkbox [checked]="showInactive()" (change)="toggleInactive($event.checked)">
        {{ 'WORKCLASSIFICATION.TEMPLATES.SHOW_INACTIVE' | translate }}
      </mat-checkbox>
    </div>

    @if (loading()) {
      <div class="table-loading"><mat-spinner diameter="32"></mat-spinner></div>
    } @else if (loadFailed()) {
      <div class="table-empty">
        <mat-icon>error_outline</mat-icon>
        <p>{{ 'WORKCLASSIFICATION.TEMPLATES.LOAD_FAILED' | translate }}</p>
        <button mat-stroked-button class="btn-secondary" (click)="load()">{{ 'WORKCLASSIFICATION.TEMPLATES.RETRY' | translate }}</button>
      </div>
    } @else if (templates().length === 0) {
      <div class="table-empty">
        <mat-icon>account_tree</mat-icon>
        <p>{{ 'WORKCLASSIFICATION.TEMPLATES.EMPTY' | translate }}</p>
      </div>
    } @else {
      <mat-card class="table-container-card">
        <mat-card-content>
          <div class="responsive-table-wrapper">
            <table mat-table [dataSource]="templates()" class="responsive-table">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'WORKCLASSIFICATION.TEMPLATES.COL_NAME' | translate }}</th>
                <td mat-cell *matCellDef="let t" class="name-cell">
                  @if (t.isDefault) {
                    <mat-icon class="default-star" [attr.aria-label]="'WORKCLASSIFICATION.TEMPLATES.DEFAULT_BADGE' | translate">star</mat-icon>
                  }
                  {{ t.name }}
                  @if (t.isDefault) {
                    <span class="status-indicator active">{{ 'WORKCLASSIFICATION.TEMPLATES.DEFAULT_BADGE' | translate }}</span>
                  }
                  @if (!t.isActive) {
                    <span class="status-indicator inactive">{{ 'WORKCLASSIFICATION.TEMPLATES.INACTIVE_BADGE' | translate }}</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>{{ 'WORKCLASSIFICATION.TEMPLATES.COL_DESCRIPTION' | translate }}</th>
                <td mat-cell *matCellDef="let t" class="description-cell">{{ t.description }}</td>
              </ng-container>

              <ng-container matColumnDef="nodeCount">
                <th mat-header-cell *matHeaderCellDef>{{ 'WORKCLASSIFICATION.TEMPLATES.COL_NODES' | translate }}</th>
                <td mat-cell *matCellDef="let t" class="count-cell">{{ t.nodeCount }}</td>
              </ng-container>

              <ng-container matColumnDef="updatedAt">
                <th mat-header-cell *matHeaderCellDef>{{ 'WORKCLASSIFICATION.TEMPLATES.COL_UPDATED' | translate }}</th>
                <td mat-cell *matCellDef="let t">{{ (t.updatedAt || t.createdAt) | date: 'd.M.y' }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let t" class="actions-cell">
                  <button mat-icon-button [matMenuTriggerFor]="rowMenu" [matMenuTriggerData]="{ t: t }" (click)="$event.stopPropagation()" [attr.aria-label]="'WORKCLASSIFICATION.TEMPLATES.MENU' | translate">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columns"></tr>
              <tr mat-row *matRowDef="let row; columns: columns" class="data-row clickable" [class.inactive-row]="!row.isActive" (click)="open(row)"></tr>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </mat-card-content>
</mat-card>

<mat-menu #rowMenu="matMenu">
  <ng-template matMenuContent let-t="t">
    <button mat-menu-item (click)="open(t)">
      <mat-icon>open_in_new</mat-icon>{{ 'WORKCLASSIFICATION.TEMPLATES.MENU_OPEN' | translate }}
    </button>
    @if (t.isActive && !t.isDefault) {
      <button mat-menu-item (click)="setDefault(t)">
        <mat-icon>star</mat-icon>{{ 'WORKCLASSIFICATION.TEMPLATES.MENU_SET_DEFAULT' | translate }}
      </button>
    }
    <button mat-menu-item (click)="openForm('edit', t)">
      <mat-icon>edit</mat-icon>{{ 'WORKCLASSIFICATION.TEMPLATES.MENU_EDIT' | translate }}
    </button>
    @if (t.isActive) {
      <button mat-menu-item (click)="deactivate(t)">
        <mat-icon>delete</mat-icon>{{ 'WORKCLASSIFICATION.TEMPLATES.MENU_DEACTIVATE' | translate }}
      </button>
    } @else {
      <button mat-menu-item (click)="reactivate(t)">
        <mat-icon>restore</mat-icon>{{ 'WORKCLASSIFICATION.TEMPLATES.MENU_REACTIVATE' | translate }}
      </button>
    }
  </ng-template>
</mat-menu>
